<template>
  <div>
    <div v-if="isPersonalizedCreditSource && getCreditBureauName">
      <MobialisCard class="mb-4 p-0">
        <img
          class="mb-3"
          :src="require(`@/assets/credit-bureaus/${getCreditBureauName}-Logo.svg`)"
          :alt="getCreditBureauName"
          width="120"
        />
        <p class="m-0">
          {{ creditBureauCardText }}
        </p>
      </MobialisCard>
    </div>
    <div v-if="isPersonalizedCreditSource && isPrequalificationEnabled">
      <MobialisCard v-if="isTDPrequalEnabled" class="mb-4 p-0">
        <img
          class="mb-3"
          :src="require(`@/assets/prequal-lenders/TD-logo.svg`)"
          :alt="PrequalFinanceProviders['TD']"
          width="40"
        />
        <p class="m-0">
          {{ $t('message.credit.application.preQualification.preQualificationCardTD') }}
        </p>
      </MobialisCard>
    </div>
    <div v-if="!isPersonalizedCreditSource && showFallbackCards">
      <div class="card border-0 shadow mb-2" v-if="getBankStrips.length">
        <div>
          <BankStrip
            class="justify-content-between"
            :creditForm="true"
            :companyList="getBankStrips"
            :logoSpacing="2"
          ></BankStrip>
        </div>
      </div>
      <DisclaimerCard
        class="card border-0 shadow mb-2"
        :iconSrc="require('@/assets/star.svg')"
        :title="$t('message.credit.preferredLendersTitle')"
        :text="`${getBusinessName} ${$t('message.credit.dealershipText')}`"
        :text-left-space="false"
      ></DisclaimerCard>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import DisclaimerCard from '@/components/DisclaimerCard.vue';
import BankStrip from '@/components/BankStrip.vue';
import { CreditDataSourceCA, PrequalFinanceProviders, PrequalFinanceProviderCodes } from '@/utils/enums';

export default {
  name: 'CreditInfoCards',
  data() {
    return {
      PrequalFinanceProviders,
      PrequalFinanceProviderCodes,
    };
  },
  components: {
    DisclaimerCard,
    BankStrip,
  },
  props: {
    showFallbackCards: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('business', [
      'getBankStrips',
      'getBusinessName',
      'getDefaultCreditDataSourceCA',
      'prequalificationFinanceProviders',
      'isPrequalificationEnabled',
      'getBusinessName',
      'isTDPrequalEnabled',
      'displayEquifaxBranding',
    ]),
    getCreditBureauName() {
      if (this.getDefaultCreditDataSourceCA === CreditDataSourceCA.CREDIT_PLUS) {
        return 'TransUnion';
      }
      if (this.displayEquifaxBranding) {
        return 'Equifax';
      }
      return null;
    },
    isPersonalizedCreditSource() {
      return this.getDefaultCreditDataSourceCA === CreditDataSourceCA.CREDIT_PLUS || this.displayEquifaxBranding;
    },
    creditBureauCardText() {
      if (!this.isPersonalizedCreditSource || !this.getCreditBureauName) {
        return null;
      }
      if (this.isPrequalificationEnabled) {
        return this.$t(`message.credit.application.preQualification.${this.getCreditBureauName.toLowerCase()}Card`);
      }
      return this.$t(`message.credit.application.${this.getCreditBureauName.toLowerCase()}CreditBureauCard`);
    },
  },
};
</script>

<style lang="scss" scoped></style>
